import * as module from "module";
import {AddAircraftComponent} from "./shared/add-aircraft.component";
import {AddDeviceComponent} from "./shared/add-device.component";
import {AircraftDetailsModule} from "./aircraft-details/aircraft-details.module";
import {AircraftInviteModule} from "./aircraft-invite/aircraft-invite.module";
import {AircraftPromotionService} from "./aircraft-promotion.service";
import {AircraftService} from "./aircraft.service";
import {MasterAircraftWakeupSettingsService} from "./master-aircraft-wakeup-settings.service";
import {AircraftShareSettingsModule} from "./aircraft-share-settings/aircraft-share-settings.module";
import {AircraftSubscriptionTrialsService} from "./aircraft-subscription-trials.service";
import {AuthGuardService} from "./auth-guard.service";
import {AvdbAttachmentModule} from "./avdb-attachment/avdb-attachment.module";
import {AvdbAttachmentService} from "./avdb-attachment/avdb-attachment.service";
import {AvdbBundleCartItemLinkerService} from "./avdb-bundle-cart-item-linker.service";
import {AvdbCartItemLinkerService} from "./avdb-cart-item-linker.service";
import {AvdbService} from "./avdb.service";
import {BrowserModule} from "@angular/platform-browser";
import {CART_ITEM_LINKERS} from "purchasing-shared/cart-item-linker";
import {CartService} from "purchasing-shared/cart.service";
import {CartFulfillmentBannersComponent} from "../purchasing/cart/cart-fulfillment-banners.component";
import {ConnectedCockpitDeviceService} from "./connected-cockpit-device.service";
import {ConnectedCockpitRegistrationService} from "./connected-cockpit-registration.service";
import {ConnextAddressTokensService} from "./connext-address-tokens.service";
import {ConnextService} from "./connext.service"
import {DatabasePricingModule} from "./database-pricing/database-pricing.module";
import {DatabasePricingService} from "./database-pricing.service";
import {DealerGuardService} from "./dealer-guard.service";
import {DeviceDetailsModule} from "./device-details/device-details.module";
import {DeviceManagementComponent}  from "./device-management.component";
import {DeviceManagementOverviewComponent} from "./device-management-overview.component";
import {DeviceService} from "./device.service";
import {DevicesListModule} from "./devices-list/devices-list.module";
import {EnablementCartItemLinkerService} from "./enablement-cart-item-linker.service";
import {EnablementPricingService} from "./enablement-pricing.service";
import {ErrorHandler, NgModule} from "@angular/core";
import {FlyCommonModule} from "fly-common/fly-common.module";
import {FlyErrorHandler} from "fly-common/fly-error-handler.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {InstallDeviceProductsModule} from "./install-device-products/install-device-products.module";
import {IntervalRequestService} from "./interval-request.service";
import {JeppesenAccountService} from "./jeppesen-account.service";
import {LocaleService} from "purchasing-shared/locale.service";
import {MasterAircraftSummaryService} from "./master-aircraft-summary.service";
import {NotFoundComponent} from "fly-common/not-found.component";
import {OemService} from "./oem.service";
import {RedemptionService} from "./redemption-management/redemption.service";
import {RouterModule, Routes} from "@angular/router";
import {SecondaryNavigationComponent} from "./secondary-navigation.component";
import {ServiceHealthService} from "./service-health.service";
import {SharedModule} from "./shared/shared.module";
import {ThirdPartyDataSharingAircraftSeriesService} from "./third-party-data-sharing-aircraft-series.service";
import {ThirdPartyDataSharingService} from "./third-party-data-sharing.service";
import {ThirdPartyService} from "./third-party.service";
import {TransferGuardService} from "./transfer-guard.service";
import {TransferModule} from "./transfer-management/transfer.module";
import {TransferService} from "./transfer-management/transfer.service";
import {UpdateScheduleComponent} from "./update-schedule.component";
import {UserDealerAccessGrantService} from "./user-dealer-access-notice/user-dealer-access-grant.service";
import {UserDealerAccessManagementComponent} from "./user-dealer-access-management/user-dealer-access-management.component";
import {UserService} from "./user.service";
import {UserInfoService} from "./user-info.service";
import {WarrantyRegistrationModule} from "./warranty-registration/warranty-registration.module";
import {DealerDeviceService} from "../dealer-customer-management/dealer-device.service";
import {DealerAircraftService} from "../dealer-customer-management/dealer-aircraft.service";
import {ValidationService} from "./validation.service";
import {TurbopropService} from "./turboprop.service";
import {DatabasePricingComponent} from "./database-pricing/database-pricing.component";
import {UserDealerAccessManagementRevokeModalComponent} from "./user-dealer-access-management/user-dealer-access-management-revoke-modal.component";
import {UserDealerAccessManagementGrantModalComponent} from "./user-dealer-access-management/user-dealer-access-management-grant-modal.component";
import {FlightAnalyticsAircraftSummaryService} from "./flight-analytics-aircraft-summary.service";
import {AvdbSubscriptionService} from "./avdb-subscription.service";
import {TelephonyService} from "./telephony.service";
import {PermissionAuthGuardService} from "./permission-auth-guard";
import {AircraftSystemService} from "./aircraft-system.service";

const routes: Routes = [
	{path: "", redirectTo: "/list?redirected=true", pathMatch: "full"},
	{path: "overview", component: DeviceManagementOverviewComponent},
	{path: "add-aircraft", component: AddAircraftComponent, canActivate: [AuthGuardService, PermissionAuthGuardService], data: {permissionIds: [module.config().permissionsAircraftEditId]}},
	{path: "add-device", component: AddDeviceComponent, canActivate: [AuthGuardService, PermissionAuthGuardService], data: {permissionIds: [module.config().permissionsDeviceEditId]}},
	{path: "update-schedule", component: UpdateScheduleComponent},
	{path: "dealer-access-management", component: UserDealerAccessManagementComponent, canActivate: [AuthGuardService]},
	{path: "database-pricing", component: DatabasePricingComponent, canActivate: [AuthGuardService, PermissionAuthGuardService], data: {permissionIds: [module.config().permissionsAvdbPurchaseId]}},
	{path: "**", component: NotFoundComponent},
];

@NgModule({
    declarations: [
        CartFulfillmentBannersComponent,
        DeviceManagementComponent,
        DeviceManagementOverviewComponent,
        SecondaryNavigationComponent,
        UpdateScheduleComponent,
        UserDealerAccessManagementComponent,
        UserDealerAccessManagementGrantModalComponent,
        UserDealerAccessManagementRevokeModalComponent
    ],
	imports: [
		AircraftDetailsModule,
		AircraftInviteModule,
		AircraftShareSettingsModule,
		AvdbAttachmentModule,
		BrowserModule,
		DatabasePricingModule,
		DeviceDetailsModule,
		DevicesListModule,
		FlyCommonModule,
		FormsModule,
		HttpModule,
		InstallDeviceProductsModule,
		ReactiveFormsModule,
		ReactiveFormsModule,
		RouterModule.forRoot(routes),
		SharedModule,
		TransferModule,
		WarrantyRegistrationModule,
	],
	providers: [
		AircraftPromotionService,
		AircraftService,
		MasterAircraftWakeupSettingsService,
		AircraftSubscriptionTrialsService,
		AircraftSystemService,
		AuthGuardService,
		AvdbAttachmentService,
		AvdbAttachmentService,
		AvdbService,
		AvdbSubscriptionService,
		CartService,
		ConnectedCockpitDeviceService,
		ConnectedCockpitRegistrationService,
		ConnextAddressTokensService,
		ConnextService,
		DatabasePricingService,
		DealerAircraftService,
		DealerDeviceService,
		DealerGuardService,
		DeviceService,
		EnablementPricingService,
		FlightAnalyticsAircraftSummaryService,
		IntervalRequestService,
		JeppesenAccountService,
		LocaleService,
		MasterAircraftSummaryService,
		OemService,
		PermissionAuthGuardService,
		RedemptionService,
		ServiceHealthService,
		TelephonyService,
		ThirdPartyDataSharingAircraftSeriesService,
		ThirdPartyDataSharingService,
		ThirdPartyService,
		TransferGuardService,
		TransferService,
		TurbopropService,
		UserDealerAccessGrantService,
		UserInfoService,
		UserService,
		ValidationService,
		{provide: "ccdEulaUrl", useValue: module.config().ccdEulaUrl},
		{provide: "connextSubscriptionRootSkuRegex", useValue: module.config().connextSubscriptionRootSkuRegex},
		{provide: "connextSubscriptionInternalTestingRootSkuRegex", useValue: module.config().connextSubscriptionInternalTestingRootSkuRegex},
		{provide: "databasePricingFaqUrl", useValue: module.config().databasePricingFaqUrl},
		{provide: "databaseInstallFaqUrl", useValue: module.config().databaseInstallFaqUrl},
		{provide: "deviceCount", useValue: module.config().deviceCount},
		{provide: "isCustomerUser", useValue: module.config().isCustomerUser},
		{provide: "isDealerUser", useValue: module.config().isDealerUser},
		{provide: "isOemDistributor", useValue: module.config().isOemDistributor},
		{provide: "isOemUser", useValue: module.config().isOemUser},
		{provide: "loggedInUserCustomerGuid", useValue: module.config().loggedInUserCustomerGuid},
		{provide: "loggedInUserEmail", useValue: module.config().loggedInUserEmail},
		{provide: "oneTimeCodeFaqUrl", useValue: module.config().oneTimeCodeFaqUrl},
		{provide: "connextDeviceModelIdList", useValue: module.config().connextDeviceModelIdList},
		{provide: "connextSubscriptionJobPollingInterval", useValue: module.config().connextSubscriptionJobPollingInterval},
		{provide: "connextSubscriptionJobPollingThreshold", useValue: module.config().connextSubscriptionJobPollingThreshold},
		{provide: "connextSubscriptionJobCompleteText", useValue: module.config().connextSubscriptionJobCompleteText},
		{provide: "connextSubscriptionJobPendingText", useValue: module.config().connextSubscriptionJobPendingText},
		{provide: "connextSubscriptionJobErrorText", useValue: module.config().connextSubscriptionJobErrorText},
		{provide: "connextSubscriptionJobCheckDayThreshold", useValue: module.config().connextSubscriptionJobCheckDayThreshold},
		{provide: "ccdOemAvdbTestBundlePartKey", useValue: module.config().ccdOemAvdbTestBundlePartKey},
		{provide: "ccdOemAvdbTestBundlePartKeyTier2", useValue: module.config().ccdOemAvdbTestBundlePartKeyTier2},
		{provide: "ccdOemAvdbTestBundlePartKeyTier3", useValue: module.config().ccdOemAvdbTestBundlePartKeyTier3},
		{provide: "satelliteServicesServiceTermsUrl", useValue: module.config().satelliteServicesServiceTermsUrl},
		{provide: "satelliteServicesTermsConditionsUrl", useValue: module.config().satelliteServicesTermsConditionsUrl},
		{provide: "terrainRegionFourNineArcSecondId", useValue: module.config().terrainRegionFourNineArcSecondId},
		{provide: "terrainRegionNineEightArcSecondId", useValue: module.config().terrainRegionNineEightArcSecondId},
		{provide: "terrainRegionUpgradableDeviceIdList", useValue: module.config().terrainRegionUpgradableDeviceIdList},
		{provide: "v2AdministratorRoleUuid", useValue: module.config().v2AdministratorRoleUuid},
		{provide: "v2AircraftRoleTypeId", useValue: module.config().v2AircraftRoleTypeId},
		{provide: "v2UserRoleUuid", useValue: module.config().v2UserRoleUuid},
		{provide: "v2UserLsqReceiveRoleUuid", useValue: module.config().v2UserLsqReceiveRoleUuid},
		{provide: "v2UserLsqTriggerRoleUuid", useValue: module.config().v2UserLsqTriggerRoleUuid},
		{provide: "v2OemRoleUuid", useValue: module.config().v2OemRoleUuid},
		{provide: "v2OemLteWifiTrialType", useValue: module.config().v2OemLteWifiTrialType},
		{provide: "v2OemAvdbTrialType", useValue: module.config().v2OemAvdbTrialType},
		{provide: "v2CustomerLteWifiTrialType", useValue: module.config().v2CustomerLteWifiTrialType},
		{provide: "v2DealerLteWifiTrialType", useValue: module.config().v2DealerLteWifiTrialType},
		{provide: 'v2OemSatelliteTrialType', useValue: module.config().v2OemSatelliteTrialType},
		{provide: 'v2CustomerSatelliteTrialType', useValue: module.config().v2CustomerSatelliteTrialType},
		{provide: 'v2DealerSatelliteTrialType', useValue: module.config().v2DealerSatelliteTrialType},
		{provide: "warrantyRegistrationCustomerDefaultGuid", useValue: module.config().warrantyRegistrationCustomerDefaultGuid},
		{provide: "warrantyRegistrationEnabled", useValue: module.config().warrantyRegistrationEnabled},
		{provide: "warrantyRegistrationPanelAircraftSerialNumberMaxLength", useValue: module.config().warrantyRegistrationPanelAircraftSerialNumberMaxLength},
		{provide: "warrantyRegistrationPanelAircraftSerialNumberMinLength", useValue: module.config().warrantyRegistrationPanelAircraftSerialNumberMinLength},
		{provide: "warrantyRegistrationPanelAircraftSerialNumberRegex", useValue: module.config().warrantyRegistrationPanelAircraftSerialNumberRegex},
		{provide: "warrantyRegistrationPanelLruG5Description", useValue: module.config().warrantyRegistrationPanelLruG5Description},
		{provide: "warrantyRegistrationPanelLruG5ItemNumbersRegex", useValue: module.config().warrantyRegistrationPanelLruG5ItemNumbersRegex},
		{provide: "warrantyRegistrationPanelLruItemNumberRegex", useValue: module.config().warrantyRegistrationPanelLruItemNumberRegex},
		{provide: "warrantyRegistrationPanelLruSerialNumberMaxLength", useValue: module.config().warrantyRegistrationPanelLruSerialNumberMaxLength},
		{provide: "warrantyRegistrationPanelLruSerialNumberMinLength", useValue: module.config().warrantyRegistrationPanelLruSerialNumberMinLength},
		{provide: "warrantyRegistrationPanelLruSerialNumberRegex", useValue: module.config().warrantyRegistrationPanelLruSerialNumberRegex},
		{provide: "warrantyRegistrationSupportEmail", useValue: module.config().warrantyRegistrationSupportEmail},
		{provide: "unfulfilledCartAcceptableWaitTimeMinutes", useValue: module.config().unfulfilledCartAcceptableWaitTimeMinutes},
		{provide: "unfulfilledCartCheckFrequencyMilliseconds", useValue: module.config().unfulfilledCartCheckFrequencyMilliseconds},
		{provide: "completedCartNoticeTimeMinutes", useValue: module.config().completedCartNoticeTimeMinutes},
		{provide: "connextServicesInfoReloadFrequencyMilliseconds", useValue: module.config().connextServicesInfoReloadFrequencyMilliseconds},
		{provide: "connextServicesInfoReloadEnabled", useValue: module.config().connextServicesInfoReloadEnabled},
		{provide: "validTailNumberRegex", useValue: module.config().validTailNumberRegex},
		{provide: "validAircraftDeviceSerialRegex", useValue: module.config().validAircraftDeviceSerialRegex},
		{provide: "validPortableDeviceSerialRegex", useValue: module.config().validPortableDeviceSerialRegex},
		{provide: "telephonyConnectedCockpitDeviceIds", useValue: module.config().telephonyConnectedCockpitDeviceIds},,
		{provide: "connextLteWifiEligibleConnectedCockpitDeviceIds", useValue: module.config().connextLteWifiEligibleConnectedCockpitDeviceIds},
		{provide: "permissionsDeviceEditId", useValue: module.config().permissionsDeviceEditId},
		{provide: "skusToNotRecommend", useValue: module.config().skusToNotRecommend},
		{provide: "onepakPilotpakFaqUrl", useValue: module.config().onepakPilotpakFaqUrl},
		{provide: "herculesModelIds", useValue: module.config().herculesModelIds},
		{provide: CART_ITEM_LINKERS, useClass: AvdbBundleCartItemLinkerService, multi: true},
		{provide: CART_ITEM_LINKERS, useClass: AvdbCartItemLinkerService, multi: true},
		{provide: CART_ITEM_LINKERS, useClass: EnablementCartItemLinkerService, multi: true},
		{provide: ErrorHandler, useExisting: FlyErrorHandler}
	],
	bootstrap: [
		DeviceManagementComponent,
	],
})
export class DeviceManagementModule { }
